import type { PowerUpKind } from '../../shared/power-ups';

/**
 * Names of the per-kind custom properties `applyTheme` writes and the board reads
 * (`--theme-power-up-<kind>-<property>`). A leaf so `game/` can bind them without
 * importing the pack registry.
 */
export const POWER_UP_TILE_PROPERTIES = [
  'glyph',
  'glyphColor',
  'background',
  'backgroundSize',
  'text',
  'border',
  'shadow',
  'transform',
  'animation',
] as const;
export type PowerUpTileProperty = (typeof POWER_UP_TILE_PROPERTIES)[number];

export const kebab = (key: string): string => key.replace(/[A-Z]/g, (letter) => `-${letter.toLowerCase()}`);

export function powerUpTileProperty(
  kind: PowerUpKind | string,
  property: PowerUpTileProperty | string,
): string {
  return `--theme-power-up-${kind}-${kebab(property)}`;
}
